import Helper from "./Helper";

class TableTitle {
  constructor(config = {}) {
    const {
      tableWrapper,
      tableTitleClass,
      tableTitlePosition
    } = config;

    this.tableWrapper = Array.prototype.slice.call(document.querySelectorAll(tableWrapper));
    this.tableTitleClass = tableTitleClass;
    this.tableTitlePosition = tableTitlePosition;
 
    if(this.tableWrapper){
      this.repositionTableTitle();
    }
  }

  repositionTableTitle() {
    this.tableWrapper.forEach(el => {
      let tableTitle = el.querySelector(this.tableTitleClass + " span");
      let moveTo = el.querySelector(this.tableTitlePosition);

      if ( !moveTo ) {
        moveTo = document.createElement('p');
        Helper.addClass(moveTo, 'ns-table-title');

        el.insertBefore(moveTo, el.firstChild);
      }

      if ( !!tableTitle && tableTitle.innerHTML != "" ) {
        moveTo.innerHTML = tableTitle.innerHTML;

        let tableTitleRow = Helper.getClosest(tableTitle, 'tr');
        tableTitleRow.remove();
      }
    });
  }
}

export default TableTitle;